import styled from "@emotion/styled";
import { Menu, MenuItem } from "@mui/material";
import type { MouseEvent, ReactNode } from "react";
import { useState } from "react";

import { IconButton, type IconButtonPropsOverride } from "./Buttons";

const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    border-radius: 6px;
    min-width: 180px;

    box-shadow:
      0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14),
      0 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
`;

type Props = IconButtonPropsOverride & {
  options: Array<{
    label: ReactNode;
    onClick: () => void;
    divider?: ReactNode;
  }>;
};

export const MenuButton = ({ options, ...rest }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        id="demo-customized-button"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        icon="plus"
        onClick={handleClick}
        {...rest}
      />
      <StyledMenu
        id="demo-customized-menu"
        elevation={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            // @ts-ignore
            "data-test": "popup-menu-container",
          },
        }}
      >
        <div data-test="list">
          {options.map((option, index) => (
            <div key={index}>
              {option.divider && <div data-test="divider">{option.divider}</div>}
              <MenuItem
                onClick={() => {
                  option.onClick();
                  handleClose();
                }}
                data-test="item"
              >
                {option.label}
              </MenuItem>
            </div>
          ))}
        </div>
      </StyledMenu>
    </>
  );
};
